/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContractorTarget,
  ContractorWriteRequest,
  ResultOfContractorMutation,
  ResultOfIReadOnlyListOfContractorListItem,
  SendContractorPacketInviteBody,
  UpdateContractorBody,
} from '../models/index';
import {
    ContractorTargetFromJSON,
    ContractorTargetToJSON,
    ContractorWriteRequestFromJSON,
    ContractorWriteRequestToJSON,
    ResultOfContractorMutationFromJSON,
    ResultOfContractorMutationToJSON,
    ResultOfIReadOnlyListOfContractorListItemFromJSON,
    ResultOfIReadOnlyListOfContractorListItemToJSON,
    SendContractorPacketInviteBodyFromJSON,
    SendContractorPacketInviteBodyToJSON,
    UpdateContractorBodyFromJSON,
    UpdateContractorBodyToJSON,
} from '../models/index';

export interface ApiContractorsArchivePostRequest {
    contractorTarget: ContractorTarget;
    xTenantID?: number;
}

export interface ApiContractorsDeletePostRequest {
    contractorTarget: ContractorTarget;
    xTenantID?: number;
}

export interface ApiContractorsGetRequest {
    archived?: boolean;
    xTenantID?: number;
}

export interface ApiContractorsIdRestorePostRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiContractorsPacketGetRequest {
    d?: string;
    xTenantID?: number;
}

export interface ApiContractorsPacketInvitePostRequest {
    sendContractorPacketInviteBody: SendContractorPacketInviteBody;
    xTenantID?: number;
}

export interface ApiContractorsPacketReturnPostRequest {
    xTenantID?: number;
    token?: string;
    note?: string;
    sendCopy?: boolean;
    replyEmail?: string;
    files?: Array<Blob>;
}

export interface ApiContractorsPacketSentPostRequest {
    contractorTarget: ContractorTarget;
    xTenantID?: number;
}

export interface ApiContractorsPostRequest {
    contractorWriteRequest: ContractorWriteRequest;
    xTenantID?: number;
}

export interface ApiContractorsPutRequest {
    updateContractorBody: UpdateContractorBody;
    xTenantID?: number;
}

/**
 * 
 */
export class ContractorsApi extends runtime.BaseAPI {

    /**
     */
    async apiContractorsArchivePostRaw(requestParameters: ApiContractorsArchivePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contractorTarget'] == null) {
            throw new runtime.RequiredError(
                'contractorTarget',
                'Required parameter "contractorTarget" was null or undefined when calling apiContractorsArchivePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contractors/archive`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContractorTargetToJSON(requestParameters['contractorTarget']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiContractorsArchivePost(requestParameters: ApiContractorsArchivePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiContractorsArchivePostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiContractorsDeletePostRaw(requestParameters: ApiContractorsDeletePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contractorTarget'] == null) {
            throw new runtime.RequiredError(
                'contractorTarget',
                'Required parameter "contractorTarget" was null or undefined when calling apiContractorsDeletePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contractors/delete`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContractorTargetToJSON(requestParameters['contractorTarget']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiContractorsDeletePost(requestParameters: ApiContractorsDeletePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiContractorsDeletePostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiContractorsGetRaw(requestParameters: ApiContractorsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIReadOnlyListOfContractorListItem>> {
        const queryParameters: any = {};

        if (requestParameters['archived'] != null) {
            queryParameters['archived'] = requestParameters['archived'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contractors`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIReadOnlyListOfContractorListItemFromJSON(jsonValue));
    }

    /**
     */
    async apiContractorsGet(requestParameters: ApiContractorsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIReadOnlyListOfContractorListItem> {
        const response = await this.apiContractorsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiContractorsIdRestorePostRaw(requestParameters: ApiContractorsIdRestorePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiContractorsIdRestorePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contractors/{id}/restore`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiContractorsIdRestorePost(requestParameters: ApiContractorsIdRestorePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiContractorsIdRestorePostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiContractorsPacketGetRaw(requestParameters: ApiContractorsPacketGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['d'] != null) {
            queryParameters['d'] = requestParameters['d'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contractors/packet`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiContractorsPacketGet(requestParameters: ApiContractorsPacketGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiContractorsPacketGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiContractorsPacketInvitePostRaw(requestParameters: ApiContractorsPacketInvitePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sendContractorPacketInviteBody'] == null) {
            throw new runtime.RequiredError(
                'sendContractorPacketInviteBody',
                'Required parameter "sendContractorPacketInviteBody" was null or undefined when calling apiContractorsPacketInvitePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contractors/packet-invite`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendContractorPacketInviteBodyToJSON(requestParameters['sendContractorPacketInviteBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiContractorsPacketInvitePost(requestParameters: ApiContractorsPacketInvitePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiContractorsPacketInvitePostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiContractorsPacketReturnPostRaw(requestParameters: ApiContractorsPacketReturnPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['token'] != null) {
            formParams.append('Token', requestParameters['token'] as any);
        }

        if (requestParameters['note'] != null) {
            formParams.append('Note', requestParameters['note'] as any);
        }

        if (requestParameters['sendCopy'] != null) {
            formParams.append('SendCopy', requestParameters['sendCopy'] as any);
        }

        if (requestParameters['replyEmail'] != null) {
            formParams.append('ReplyEmail', requestParameters['replyEmail'] as any);
        }

        if (requestParameters['files'] != null) {
            requestParameters['files'].forEach((element) => {
                formParams.append('Files', element as any);
            })
        }


        let urlPath = `/api/contractors/packet-return`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiContractorsPacketReturnPost(requestParameters: ApiContractorsPacketReturnPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiContractorsPacketReturnPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiContractorsPacketSentPostRaw(requestParameters: ApiContractorsPacketSentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contractorTarget'] == null) {
            throw new runtime.RequiredError(
                'contractorTarget',
                'Required parameter "contractorTarget" was null or undefined when calling apiContractorsPacketSentPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contractors/packet-sent`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContractorTargetToJSON(requestParameters['contractorTarget']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiContractorsPacketSentPost(requestParameters: ApiContractorsPacketSentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiContractorsPacketSentPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiContractorsPostRaw(requestParameters: ApiContractorsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfContractorMutation>> {
        if (requestParameters['contractorWriteRequest'] == null) {
            throw new runtime.RequiredError(
                'contractorWriteRequest',
                'Required parameter "contractorWriteRequest" was null or undefined when calling apiContractorsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contractors`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContractorWriteRequestToJSON(requestParameters['contractorWriteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfContractorMutationFromJSON(jsonValue));
    }

    /**
     */
    async apiContractorsPost(requestParameters: ApiContractorsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfContractorMutation> {
        const response = await this.apiContractorsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiContractorsPutRaw(requestParameters: ApiContractorsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfContractorMutation>> {
        if (requestParameters['updateContractorBody'] == null) {
            throw new runtime.RequiredError(
                'updateContractorBody',
                'Required parameter "updateContractorBody" was null or undefined when calling apiContractorsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/contractors`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateContractorBodyToJSON(requestParameters['updateContractorBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfContractorMutationFromJSON(jsonValue));
    }

    /**
     */
    async apiContractorsPut(requestParameters: ApiContractorsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfContractorMutation> {
        const response = await this.apiContractorsPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
